import { Controller } from '@hotwired/stimulus';
import { Popover } from 'bootstrap';

export default class extends Controller<HTMLLinkElement> {
  static values = {
    message: { type: String, default: 'URL copied!' },
    duration: { type: Number, default: 2000 }
  };

  declare readonly messageValue: string;
  declare readonly durationValue: number;
  private popover: Popover | null = null;

  connect(): void {
    if (!(this.element instanceof HTMLAnchorElement)) {
      console.warn('CopyUrlController should be attached to an <a> element');
      return;
    }

    // Initialize Bootstrap popover
    this.popover = new Popover(this.element, {
      trigger: 'manual',
      placement: 'right',
      content: '',
      container: 'body'
    });
  }

  disconnect(): void {
    this.popover?.dispose();
  }

  async copy(event: Event): Promise<void> {
    event.preventDefault();

    try {
      const url = this.element.href;
      await navigator.clipboard.writeText(url);
      this.showPopover(this.messageValue);
    } catch (error) {
      console.error('Copy failed:', error);
    }
  }

  private showPopover(message: string): void {
    if (!this.popover) return;

    // Update popover content and style
    this.element.setAttribute('data-bs-original-title', message);
    this.popover.setContent({
      '.popover-body': message
    });

    // Show popover
    this.popover.show();

    // Hide after duration
    setTimeout(() => {
      this.popover?.hide();
    }, this.durationValue);
  }
}